<template>
  <div id="app">
    <layoutTopbar></layoutTopbar>
    <slot />
  </div>
</template> 

<script>
import layoutTopbar from '@/components/layout/layout-topbar'
import InitMixin from './initMixin'

export default {
  mixins: [InitMixin],
  components: {
    layoutTopbar,
  },
}
</script>

<style  scoped="scoped">
 
</style>
